import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#D70926',
    primaryDark: '#b0071e',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/schlienztours-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/schlienztours-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/schlienztours-logo.png',

    availableProducts: ["Zustandsbericht", "Tours"],
});